import { render, staticRenderFns } from "./PromoterList.vue?vue&type=template&id=57ccbf8e"
import script from "./PromoterList.vue?vue&type=script&lang=js"
export * from "./PromoterList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports